// extracted by mini-css-extract-plugin
export var root = "cards-module--root--k7psg";